import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allManagers } from 'app/mocks/data/park/managers'
import { allUsersKonsole } from 'app/mocks/data/users/konsole'
import { allProfiles } from 'app/mocks/data/users/profiles'

import { api } from 'app/utils/constants'

import { KonsoleUser, KonsoleUserPayload } from 'app/types/users/konsole'

export const updateUserKonsole = http.patch(
    `${process.env.REACT_APP_API_ADDRESS}/${api.users.konsole.DETAILS}`,
    async ({ request, params }) => {
        const { id } = params
        const payload = await request.json()
        const payloadParsed = KonsoleUserPayload.safeParse(payload)

        const userKonsoleFound = allUsersKonsole.find(
            (user) => user.id.toString() === id,
        )

        // Wrong data
        if (!payloadParsed.success) {
            return new HttpResponse(null, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        // Not found
        if (!userKonsoleFound) {
            return new HttpResponse(null, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json<KonsoleUser>({
            ...userKonsoleFound,
            ...payloadParsed.data,
            groups: allProfiles.filter((profile) =>
                payloadParsed.data.groups.includes(profile.id),
            ),
            profil: {
                client: allManagers.filter((manager) =>
                    payloadParsed.data.profil.client.includes(manager.id),
                ),
            },
        })
    },
)
